import formatters from 'lib/formatters'
import { legibleDepositType } from '../depositUtils.js'

export const getDepositTypeLabel = (depositType) => {
  if (formatters.legibleDepositType) {
    return formatters.legibleDepositType(depositType).toUpperCase()
  }
  return legibleDepositType(depositType)
}

export const safeGet = (obj, path, fallback = '') => {
  return path.split('.').reduce((current, key) => current?.[key], obj) ?? fallback
}

export const normalizeAccountName = (accountName) => {
  if (!accountName) return ''
  return accountName.replace(/_/g, ' ').toLowerCase().trim()
}
